module.exports = new __parcel__URL__("darkModeInlineComment.186fb503.gif").toString();